import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: []

})
export class InlineGraphsModule {}



// WEBPACK FOOTER //
// ./src/app/shared/graphs/inline/inline-graphs.module.ts